var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-content"},[_c('h1',{staticClass:"client-title"},[_vm._v("클라이언트 다운로드")]),_vm._v(" "),_c('div',{staticClass:"client-down-box"},[_c('div',{staticClass:"client-down-tag"},[_vm._v("VaRoon Client 1.1")]),_vm._v(" "),_c('button',{staticClass:"client-down-button",on:{"click":_vm.showImpossible}},[_vm._v("\n      Download\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6a54f26","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MarketManager/ClientDownload.vue
// module id = 197
// module chunks = 0